import { render } from "./weights-panel.vue?vue&type=template&id=9a65fa56&scoped=true&ts=true"
import script from "./weights-panel.vue?vue&type=script&lang=ts"
export * from "./weights-panel.vue?vue&type=script&lang=ts"

import "./weights-panel.vue?vue&type=style&index=0&id=9a65fa56&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a65fa56"]])

export default __exports__